import { Center } from '@mantine/core';
import { ComponentType, ElementType, Suspense, lazy } from 'react';
import { PiAirplaneInFlight } from 'react-icons/pi';


const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoaderComponent />}>
    <Component {...props} />
  </Suspense>
);

export function LazyPage(callback: () => Promise<{ default: ComponentType<any> }>) {
  const Component = Loadable(lazy(callback));
  return <Component />;
}

export const LoaderComponent = () => {
  return (
    <Center h="90vh">
      <PiAirplaneInFlight size={60} className="spinning-airplane" />
    </Center>
  );
};